<template>
  <div class="com">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="title">
      <div class="title-txt">
        <div class="button-container">
          KIT LIST
          <span class="title-txt-span" v-if="allKits.length > 0"
            >{{ allKits.length }} Total</span
          >
          <button class="print-btn" @click="back">Back</button>
        </div>
      </div>
      <div class="title-date">
        <span class="title-date-span">Sort by:</span>
        <button class="btn btn-date">
          Date of Submission
        </button>
      </div>
    </div>
    <div class="search-input-wrap" v-if="allKits.length > 0">
      <img
        src="../../images/dashboard/search.png"
        alt="#"
        class="search-input-img"
      />
      <input
        type="text"
        class="search-input"
        placeholder="Search..."
        v-model="searchModel"
        @keyup.enter="filterKits"
      />
    </div>
    <div class="wrap" v-if="filteredKits.length > 0">
      <div class="date-wrap" v-for="item in filteredKits" :key="item.id">
        <div class="col">
          <div class="item">
            <div class="item-title">Kit ID</div>
            <div class="item-val kit" @click="showThisKit(item)">
              {{ convertKitId(item.kit_id) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">Status</div>
            <div class="status-wrap">
              <div class="item-val">
                <span v-if="statusOf(item) === 'shipped'">
                  <span class="circle blue"></span>Sold
                </span>
                <span v-if="statusOf(item) === 'activated'">
                  <span class="circle"></span>Activated
                </span>
                <span v-if="statusOf(item) === 'delivered'">
                  <span class="circle skyblue"></span>Delivered
                </span>
                <span v-if="statusOf(item) === 'lab_received'">
                  <span class="circle orange"></span>Lab Received
                </span>
                <span v-if="statusOf(item) === 'accepted'">
                  <span class="circle" style="background-color: #0EA5E9;"></span>Accepted
                </span>
                <span v-if="statusOf(item) === 'dna_extraction'">
                  <span class="circle" style="background-color: #17A2B8;"></span>DNA Extraction In Progress
                </span>
                <span v-if="statusOf(item) === 'sequencing'">
                  <span class="circle" style="background-color: #6F42C1;"></span>Sequencing In Progress
                </span>
                <span v-if="statusOf(item) === 'lab_awaiting'">
                  <span class="circle purple"></span>Submitted
                </span>
                <span v-if="statusOf(item) === 'on_hold'">
                  <span class="circle" style="background-color: #E87A01;"></span>On Hold
                </span>
                <span v-if="statusOf(item) === 'analysis_completed'">
                  <span class="circle green"></span>Analysis Complete
                </span>
                <span v-if="statusOf(item) === 'analysis_failed'">
                  <span class="circle red"></span>Analysis Failed
                </span>
                <span v-if="statusOf(item) === 'partially_failed'">
                  <span class="circle green"></span>Partially Complete
                </span>
                <span v-if="statusOf(item) === 'archive'">
                  <span class="circle orange"></span>Archived
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="item">
            <div class="item-title">Date of Submission</div>
            <div class="item-val">
              {{ date(item.submission_at) }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">Date of Activation</div>
            <div class="item-val">
              {{ date(item.activated_at) }}
            </div>
          </div>
        </div>
        <div class="col version-col">
          <span class="version-badge" :class="item._version === 'v2' ? 'v2' : 'v1'">
            {{ item._version === 'v2' ? 'Air' : 'Dust' }}
          </span>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      No kits found.
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import CloseIcone from "../../images/shared/cancel";

const STATUS_MAP = {
  0: "shipped", 1: "activated", 2: "lab_awaiting", 3: "lab_received",
  4: "on_hold", 5: "analysis_completed", 6: "problem", 7: "delivered",
  8: "archive", 9: "returned", 10: "analysis_failed", 11: "partially_failed", 12: "in_active",
  13: "dna_extraction", 14: "sequencing", 15: "report_ready", 16: "accepted"
};

export default {
  name: "ModalKitsV2",
  data() {
    return {
      allKits: [],
      searchModel: null
    };
  },
  components: {
    CloseIcone
  },
  computed: {
    ...mapGetters(["getUserInfoV2"]),
    filteredKits() {
      if (!this.searchModel) return this.allKits;
      const q = this.searchModel.toLowerCase();
      return this.allKits.filter(kit => {
        const kitId = (kit.kit_id || "").toLowerCase();
        const status = this.statusOf(kit).toLowerCase();
        return kitId.includes(q) || status.includes(q);
      });
    }
  },
  methods: {
    ...mapActions(["testKitInfoV2", "testKitInfo", "clearInfoV2"]),
    statusOf(item) {
      const s = item.status;
      // DNA Extraction (13) and Sequencing (14) are now distinct business statuses
      // the lab drives before Lab Received (3), so the business status maps
      // directly to the displayed stage — no timestamp-based derivation needed.
      return typeof s === "string" ? s : (STATUS_MAP[s] || "shipped");
    },
    date(localDate) {
      if (localDate) {
        let date = localDate;
        const pos = localDate.indexOf("T");
        if (pos > -1) {
          date = localDate.substring(0, pos);
        }
        const formatted = moment(date).format("MMMM Do, YYYY");
        return formatted === "Invalid date" ? "00/00/0000" : formatted;
      }
      return "";
    },
    closeModal() {
      this.clearInfoV2();
      this.$emit("closeModal", false);
    },
    showThisKit(item) {
      if (item._version === "v2") {
        this.testKitInfoV2(item.id).then(() => {
          this.$emit("changeDescModal", false);
        });
      } else {
        this.testKitInfo(item.id).then(() => {
          this.$emit("changeDescModal", false);
        });
      }
    },
    back() {
      this.$emit("changeDescModal", false);
    },
    convertKitId(kitId) {
      if (!kitId) return "";
      const raw = kitId.replace(/[-\s]/g, "").substr(0, 11).toUpperCase();
      if (raw.length < 11) return raw;
      return `${raw.substr(0, 2)}-${raw.substr(2, 2)}-${raw.substr(4, 3)}-${raw.substr(7, 4)}`;
    },
    filterKits() {
      // filtering is done via computed property
    }
  },
  mounted() {
    const user = this.getUserInfoV2;
    if (user !== null) {
      const v1Kits = (user.testkits || []).map(k => ({ ...k, _version: "v1" }));
      const v2Kits = (user.kitsV2 || []).map(k => ({ ...k, _version: "v2" }));
      this.allKits = [...v1Kits, ...v2Kits];
    }
  }
};
</script>

<style scoped>
.wrap {
  height: 530px;
  overflow: auto;
}
.col {
  width: 50%;
}
.version-col {
  width: auto;
  display: flex;
  align-items: flex-start;
  padding-top: 20px;
}
.item {
  margin: 0 0 30px 0;
  position: relative;
}
.item-title {
  margin: 0 0 20px 0;
  color: #000;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.item-val {
  color: #000;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  position: relative;
}
.date-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 0 0 0;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.com {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 25px 30px;
  position: relative;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 0 0;
  color: #005eb8;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.title-txt-span {
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.title-date-span {
  color: #b3b3b3;
  padding: 0 5px 0 0;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.btn {
  outline: none;
  border: 1px solid transparent;
  padding: 0;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 160px;
  width: 100%;
  color: #000;
  line-height: 1.3;
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
  cursor: pointer;
}
.title-date {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 230px;
  width: 100%;
}
.circle.green {
  background-color: green;
}
.circle.red {
  background-color: red;
}
.circle.orange {
  background-color: orange;
}
.circle.purple {
  background-color: #ac75bd;
}
.circle.blue {
  background-color: #03409a;
}
.circle.skyblue {
  background-color: #87CEEB;
}
.circle {
  display: inline-block;
  margin: 0 5px 0 0;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #cccdcf;
}
.item-val.kit:hover {
  color: #005eb8;
  cursor: pointer;
}
.search-input-wrap {
  margin: 10px 0 0 0;
  position: relative;
  border-bottom: 2px solid #eee;
}
.search-input-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 22px;
  height: auto;
}
.search-input {
  width: 100%;
  height: 30px;
  padding: 0 0 0 40px;
  border: none;
  background-color: #fff;
  color: #000;
  outline: none;
  font-size: 16px;
  font-family: TTNormsLight, sans-serif;
}
.search-input::placeholder {
  color: #98a4ae;
}
.print-btn {
  width: 90px;
  height: 30px;
  background-color: #1546ad;
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
}
.button-container {
  display: flex;
  align-items: center;
}
.version-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-family: TTNormsMedium, sans-serif;
  color: #fff;
}
.version-badge.v1 {
  background-color: #005eb8;
}
.version-badge.v2 {
  background-color: #28a745;
}
.no-data {
  padding: 40px 0;
  text-align: center;
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
</style>
